<template>
  <div>
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">
          产品中心<span>即刻开启全新体验</span>
        </h1>
        <p class="banner-desc aw-anim">
          AI智能体｜智慧农业APP｜管理系统｜智慧门店收银等，多行业多场景应用体验
        </p>
        <button class="banner-btn aw-anim" @click="onView">
          立即查看
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>
    <!-- <div style="height: 64px;background-color: #ffffff;"></div> -->
    <div class="product">
      <!-- 整页竖向轮播：10 个产品逐屏切换 -->
      <el-carousel
        ref="mainCarousel"
        direction="vertical"
        :autoplay="false"
        height="100vh"
        indicator-position="none"
        arrow="never"
        @change="onCarouselChange"
      >
        <el-carousel-item v-for="(p, idx) in products" :key="p.id">
          <section
            class="product-section"
            :class="{ 'is-active': activeIndex === idx }"
            :style="{ backgroundColor: p.bgColor }"
          >
            <div class="section-inner">
              <!-- 左侧：产品信息 -->
              <div class="product-info">
                <img
                  class="product-logo aw-anim"
                  :src="p.logo"
                  :alt="p.title"
                />
                <h2 class="product-title aw-anim">{{ p.title }}</h2>
                <p class="product-desc aw-anim">{{ p.desc }}</p>
                <div
                  v-if="p.downloadlink"
                  class="download-tip aw-anim"
                  style="cursor: pointer"
                  @click="downloadApp(p.downloadlink)"
                >
                  点击下载
                </div>
                <div v-if="p.qrcode" class="download-tip aw-anim">
                  扫码下载，体验更多
                </div>
                <img
                  v-if="p.qrcode"
                  class="product-qrcode"
                  :src="p.qrcode"
                  alt="下载二维码"
                />
              </div>

              <!-- 右侧：产品界面小轮播 -->
              <div class="product-img aw-anim">
                <img :src="p.img" :alt="`${p.title}界面`" class="phone-img" />
              </div>
            </div>
          </section>
        </el-carousel-item>
      </el-carousel>

      <!-- 右侧固定悬浮指示器 -->
      <aside class="product-indicators">
        <button
          v-for="(p, idx) in products"
          :key="p.id"
          class="product-indicator"
          :class="{ active: activeIndex === idx }"
          :title="p.title"
          @click="onIndicatorClick(idx)"
        >
          <img :src="p.logor" :alt="p.title" />
        </button>
      </aside>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      activeIndex: 0,
      // 滚轮锁：一次手势只翻一屏，避免惯性滚动连翻多屏
      wheelLock: false,
      wheelEndTimer: null,
      wheelMaxTimer: null,
      lastSwitchTs: 0,
      products: [
        {
          id: "p1",
          title: "云小稼智能体",
          logo: require("@/assets/product/logo1.png"),
          logor: require("@/assets/product/logoR1.png"),
          qrcode: require("@/assets/app_images/云小稼-app下载码.png"),
          desc: "云小稼是云稼农业产业互联网智能生态平台的统一 AI 交互入口，基于农业认知引擎、知识图谱、行业大模型、RAG 检索增强技术打造的农业垂直领域智能体。并非独立悬浮 AI 工具，深度内嵌平台全部业务模块，打通生产、服务、交易、管理全场景，面向农户、农资门店、农服服务商、企业运营人员、政府管理人员，提供 7×24 小时智能化服务，实现 “AI 嵌入业务，而不是独立悬浮” 的产品设计原则",
          bgColor: "#ffffff",
          img: require("@/assets/product/phone1.png"),
        },
        {
          id: "p2",
          title: "云稼智慧农业 ",
          logo: require("@/assets/product/logo2.png"),
          logor: require("@/assets/product/logoR2.png"),
          qrcode: require("@/assets/app_images/云稼智农-app下载页.png"),
          desc: "云稼智慧农业平台是产业互联网平台的生产核心，面向农场、合作社、种植大户，实现地块、作物、农事、农机、投入品全流程数字化管理。联动云小稼 AI 智能体，提供智能巡田、农事推荐、风险预警能力，生产数据向上对接数据大脑与交易应用，打通从田间生产到产销交易的数据链路",
          bgColor: "#F5F8FE",
          img: require("@/assets/product/phone2.png"),
        },
        {
          id: "p3",
          title: "云稼集配",
          logo: require("@/assets/product/logo3.png"),
          logor: require("@/assets/product/logoR3.png"),
          qrcode: require("@/assets/app_images/云稼集配-太阳码.jpg"),
          desc: "云稼集配是农资供应链平台 B 端集采批发小程序，面向经销商、县域服务商、乡镇农资门店。实现农资商品线上选品、批量下单、调拨配送、对账结算全流程线上化，打通上游供应商到线下门店流通链路，依托平台交易中台，简化集采流程，降低采购与流通成本，实现农资货源可管、流向可溯",
          bgColor: "#ffffff",
          img: require("@/assets/product/phone3.png"),
        },
        {
          id: "p4",
          title: "橙兴通",
          logo: require("@/assets/product/logo4.png"),
          logor: require("@/assets/product/logoR4.png"),
          qrcode: require("@/assets/app_images/橙心通-太阳码.jpg"),
          desc: "橙兴通是面向柑橘特色产区的产业垂直小程序，打造农资、农服、鲜果产销三位一体数字化服务平台。面向柑橘种植户、乡镇门店、社会化服务队，实现农资采购、农服预约、果园管理、鲜果撮合交易，联动云小稼 AI 提供柑橘专属农技服务，助力特色水果产业全链条数字化升级",
          bgColor: "#F5F8FE",
          img: require("@/assets/product/phone4.png"),
        },
        {
          id: "p5",
          title: "云稼田头市场",
          logo: require("@/assets/product/logo5.png"),
          logor: require("@/assets/product/logoR5.png"),
          qrcode: require("@/assets/app_images/云稼田头市场-太阳码.jpg"),
          desc: "云稼金花田头市场是产地农产品 B2B 交易小程序，线上交易平台结合线下田头集货网点。面向种植户、产地经纪人、采购商，实现货源发布、线上询价撮合、行情查看、订单履约、产地集货，打通田间到客商流通链路，助力本地大宗农产品出村上行",
          bgColor: "#ffffff",
          img: require("@/assets/product/phone5.png"),
        },
        {
          id: "p6",
          title: "云稼销客",
          logo: require("@/assets/product/logo6.png"),
          logor: require("@/assets/product/logoR6.png"),
          qrcode: require("@/assets/app_images/云稼分销-太阳码.jpg"),
          desc: "云稼销客是面向农业经营主体的分销裂变与私域增长工具，归属于客户增长平台。支持渠道、门店、农户社交分销推广，通过微信分享链接实现商品传播、成交分佣；打通订单、会员、客户画像能力，构建交易获客-复购运营增长飞轮，帮助农资、农产品商家低成本拓展销售渠道",
          bgColor: "#F5F8FE",
          img: require("@/assets/product/phone6.png"),
        },
        {
          id: "p7",
          title: "云稼旺店",
          logo: require("@/assets/product/logo7.png"),
          logor: require("@/assets/product/logoR7.png"),
          qrcode: require("@/assets/app_images/旺店-app下载页.png"),
          desc: "云稼旺店是农资门店移动端经营管理工具，属于智慧门店三端协同体系。面向农资店主与店员，实现商品管理、库存管控、采购进货、会员营销、赊销台账、农服接单一体化管理；联动 POS 收银、村村团农户小程序，对接云稼集配、云小稼 AI，助力传统农资门店升级为数字化农业综合服务站点",
          bgColor: "#ffffff",
          img: require("@/assets/product/phone7.png"),
        },
        {
          id: "p8",
          title: "云稼Pos收银",
          logo: require("@/assets/product/logo8.png"),
          logor: require("@/assets/product/logoR8.png"),
          qrcode: null,
          desc: "云稼收银台是农资门店前台收银终端，为智慧门店三端协同重要组成部分。支持扫码开单、多方式收款、赊销记账、小票打印、券码核销；线下销售数据实时同步云稼旺店与村村团，实现线上线下一盘货，适配乡镇农资门店前台高频收银业务",
          bgColor: "#F5F8FE",
          img: require("@/assets/product/phone8.png"),
          downloadlink:
            "https://h5.yungia.net/yjkj_download_tauri_cash/index.html",
        },
        {
          id: "p9",
          title: "村村团",
          logo: require("@/assets/product/logo9.png"),
          logor: require("@/assets/product/logoR9.png"),
          qrcode: require("@/assets/app_images/村村团-太阳码.jpg"),
          desc: "云稼村村团是面向农户的 C 端微信小程序，为智慧门店三端协同的农户用户端。支持农资线上下单、农服预约、AI 农技咨询，支持到店自提、配送到家；数据实时联动云稼旺店、云稼收银台，打通乡镇门店与农户，构建乡村一站式农业服务入口",
          bgColor: "#ffffff",
          img: require("@/assets/product/phone9.png"),
        },
        {
          id: "p10",
          title: "顺带哥",
          logo: require("@/assets/product/logo10.png"),
          logor: require("@/assets/product/logoR10.png"),
          qrcode: require("@/assets/app_images/顺带哥-太阳码.jpg"),
          desc: "云稼顺带哥是面向农业场景的物流调度小程序，属于农业物流平台。整合县域司机、配送运力，支撑农资下乡、农产品出村双向物流；实现下单派单、路线规划、在途跟踪、签收结算全流程，与田头市场、村村团、橙兴通打通，补齐农业产业最后一公里物流履约能力",
          bgColor: "#F5F8FE",
          img: require("@/assets/product/phone10.png"),
        },
      ],
    };
  },
  mounted() {
    // 必须 passive: false，否则无法 preventDefault 阻止页面滚动
    window.addEventListener("wheel", this.onWheel, { passive: false });
  },
  beforeDestroy() {
    window.removeEventListener("wheel", this.onWheel);
    clearTimeout(this.wheelEndTimer);
    clearTimeout(this.wheelMaxTimer);
  },
  methods: {
    // 查看产品详情
    onView() {
      //滚动到产品详情区域,带动画
      window.scrollTo(0, document.querySelector(".product").offsetTop, 3000);
    },
    // 下载应用
    downloadApp(link) {
      window.open(link, "_blank");
    },
    // 外部整页轮播切换时同步指示器高亮
    onCarouselChange(current) {
      this.activeIndex = current;
    },
    getCarouselEl() {
      const c = this.$refs.mainCarousel;
      return c ? c.$el : null;
    },
    // 轮播是否已"吸顶占满"视口：顶部 banner 已滚完，且轮播仍覆盖大部分视口
    // 只有在这个状态下才接管滚轮，否则一律交给页面自然滚动
    isCarouselPinned() {
      const el = this.getCarouselEl();
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;
      return rect.top <= 4 && rect.bottom >= vh * 0.6;
    },
    // 拦截瞬间把页面精确对齐到轮播顶部，避免出现半屏错位
    snapToCarousel() {
      const el = this.getCarouselEl();
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (Math.abs(rect.top) > 1) {
        window.scrollTo(0, window.pageYOffset + rect.top);
      }
    },
    // 一次手势只翻一屏：滚轮停止 260ms 后解锁，最长 900ms 兜底解锁
    lockWheel() {
      this.wheelLock = true;
      clearTimeout(this.wheelEndTimer);
      clearTimeout(this.wheelMaxTimer);
      this.wheelEndTimer = setTimeout(() => {
        this.wheelLock = false;
      }, 260);
      this.wheelMaxTimer = setTimeout(() => {
        this.wheelLock = false;
      }, 900);
    },
    // 滚轮接管逻辑（挂在 window 上，不再挂在 el-carousel 上）
    onWheel(e) {
      const delta = e.deltaY;
      if (!delta) return;

      // 轮播还没滚到视口（顶部 banner 还在）→ 页面自然滚动
      if (!this.isCarouselPinned()) return;

      const isFirst = this.activeIndex === 0;
      const isLast = this.activeIndex === this.products.length - 1;
      const isDown = delta > 0;

      // 边界放行：最后一屏继续向下 → 页面滚到 footer
      // 第一屏继续向上 → 页面滚回顶部 banner
      if (isDown ? isLast : isFirst) return;

      // 轮播还没走完 → 锁住页面滚动，转接成轮播翻页
      e.preventDefault();
      this.snapToCarousel();

      // 冷却中 / 上一次翻屏动画还没走完 → 只锁滚动，不重复翻屏
      if (this.wheelLock || Date.now() - this.lastSwitchTs < 500) return;
      this.lockWheel();
      this.lastSwitchTs = Date.now();

      const carousel = this.$refs.mainCarousel;
      if (!carousel) return;
      if (isDown) {
        carousel.next();
      } else {
        carousel.prev();
      }
    },
    // 点击右侧指示器切换到对应产品（顺便把轮播滚进视口）
    onIndicatorClick(idx) {
      const carousel = this.$refs.mainCarousel;
      if (carousel) carousel.setActiveItem(idx);
      this.$nextTick(this.scrollCarouselIntoView);
    },
    scrollCarouselIntoView() {
      const el = this.getCarouselEl();
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (Math.abs(rect.top) > 1) {
        window.scrollTo({
          top: window.pageYOffset + rect.top,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  height: auto;
  height: 564px;
  background: url("../../assets/product/banner.png") no-repeat center center;
  background-size: 100% 100%;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
  span {
    color: #333333;
  }
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

.product {
  height: 100vh;
  /* padding-top: 64px; */
  width: 100%;
  background: #ffffff;
  position: relative;
}

/* 外部整页轮播的每一屏 */
.product-section {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.section-inner {
  width: 100%;
  height: 100%;
  /* padding: 0 260px 0 120px; */
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

/* 左侧产品信息 */
.product-info {
  flex: 0 0 558px;
}

.product-logo {
  width: 80px;
  height: 80px;
  border-radius: 16px;
  margin-bottom: 24px;
  display: block;
}

.product-title {
  font-size: 28px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 16px;
}

.product-desc {
  font-size: 16px;
  line-height: 28px;
  color: #333333;
  margin: 0 0 32px;
}

.download-tip {
  font-size: 16px;
  color: #3982f7;
  line-height: 16px;
  margin-bottom: 16px;
}

.product-qrcode {
  width: 120px;
  height: 120px;
  border: 1px solid #eef0f5;
  border-radius: 4px;
  display: block;
}

.product-img {
  width: 0;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  height: 100%;
}

.phone-img {
  width: 100%;
  max-width: 380px;
  height: auto;
  /* max-height: 600px; */
  object-fit: cover;
}

/* 右侧固定悬浮指示器 */
.product-indicators {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: absolute;
  gap: 24px;
  right: 8.6%;
  top: 184px;
  /* bottom: 40px; */
  z-index: 100;
}

.product-indicator {
  width: 32px;
  height: 32px;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  padding: 0;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.product-indicator:hover {
  transform: scale(1.1);
}

/* 当前 active 指示器：放大 + 蓝边 + 光晕 */
.product-indicator.active {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 0.09rem 0.18rem 0px;
  transform: scale(1.5);
}

.product-indicator img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  display: block;
}
</style>
